import angular from 'angular';

module.exports = angular.module('market.components.od-brokerage-info', [])
.component('odBrokerageInfo', {
  bindings: {
    brokerage: '<',
  },
  template: require('./od-brokerage-info.jade')(),
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/components/od-brokerage-info.js
 **/